var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIm19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 99,
    viewBox: "0 0 80 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.9043,
    y: 0.75,
    width: 97.1488,
    height: 78.1544,
    transform: "rotate(90 78.9043 0.75)",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9688,
    y: 24.9912,
    width: 72.9074,
    height: 78.2195,
    transform: "rotate(90 78.9688 24.9912)",
    fill: "#F1F458",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9688,
    y: 49.3213,
    width: 24.2478,
    height: 78.2195,
    transform: "rotate(90 78.9688 49.3213)",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9688,
    y: 24.9912,
    width: 24.2478,
    height: 78.2195,
    transform: "rotate(90 78.9688 24.9912)",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78.9688,
    y: 0.75,
    width: 24.2478,
    height: 78.2195,
    transform: "rotate(90 78.9688 0.75)",
    fill: "#FFFBF7",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIm19);
export default __webpack_public_path__ + "static/media/im19.f25db3ca40390ef4fe0f639f1043ea83.svg";
export { ForwardRef as ReactComponent };